import React from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountdown from '../useCountdown';
import FrameComponent from './frame';
import { Container, Frame, FrameContainer, Time, Title } from './styles';

function CountdownChristmasHat({ data, styles }) {
  const haveTitle = !!data.title;

  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'notoSans'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'notoSans'];

  const [hours, minutes, seconds] = useCountdown({
    audioUrl: data.audioUrl,
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container>
        <FrameContainer>
          <Frame>
            <FrameComponent />
          </Frame>
          <Time
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
              lineHeight: styles?.timer?.size
                ? `${styles?.timer?.size}px`
                : undefined,
            }}
          >
            {`${hours}:${minutes}:${seconds}`}
          </Time>
        </FrameContainer>
        {haveTitle && (
          <Title
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
              textShadow: `2px 2px ${styles?.title?.border}, -2px 2px ${styles?.title?.border}, 1px -2px ${styles?.title?.border}, -2px -2px ${styles?.title?.border}, 1px 1px 3px #555`,
            }}
          >
            {data.title}
          </Title>
        )}
      </Container>
    </>
  );
}

CountdownChristmasHat.propTypes = {
  data: PropTypes.shape({
    audioUrl: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      boder: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountdownChristmasHat.defaultProps = {
  data: {
    audioUrl: null,
    status: 'paused',
    time: [],
    title: 'Time Remaining',
  },
  styles: {
    timer: {
      color: '#cf0101',
      font: 'notoSans',
      letterSpacing: 1,
      size: 82,
    },
    title: {
      border: '#ffffff',
      color: '#cf0101',
      font: 'notoSans',
      letterSpacing: 1,
      size: 36,
    },
  },
};

export default CountdownChristmasHat;
